import { Outlet } from 'react-router-dom';
import Header from '../Header';
import s from './layout.module.css';
import {Container} from "react-bootstrap";

const Layout = () => {
  return (
    <div className={s.wrapper}>
      <Header />
      <div className={`${s.contentWrapper}`}>
        <Container>
            <Outlet />
        </Container>
      </div>
    </div>
  );
};

export default Layout;
